// extracted by mini-css-extract-plugin
export default {"container":"ClientForm_container__97NPP","body":"ClientForm_body__Ou5Zw","buttonCancel":"ClientForm_buttonCancel__7L3ul"};